import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Performances (Live)", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("iframe", {
  width: "100%",
  height: "450",
  scrolling: "no",
  frameborder: "no",
  allow: "autoplay",
  src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1322369266&color=%23ff5500&auto_play=true&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"10px","color":"#cccccc","line-break":"anywhere","word-break":"normal","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis","font-family":"Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif","font-weight":"100"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://soundcloud.com/jqrgen",
    title: "jQrgen",
    target: "_blank",
    style: {"color":"#cccccc","text-decoration":"none"}
  }, "jQrgen"),
  /*#__PURE__*/_createTextVNode(" · "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://soundcloud.com/jqrgen/sets/doener-tallrik-dj-bord",
    title: "Döner Tallrik & Dj Bord",
    target: "_blank",
    style: {"color":"#cccccc","text-decoration":"none"}
  }, "Döner Tallrik & Dj Bord")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3
  ], 64))
}